/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, ElementRef, inject, OnDestroy, OnInit } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { ZIndexUtils } from "primeng/utils";

import { RoutedOutletService } from '@irian-ro/navigation-module';
import { BsButtonDirective, BsButtonIconDirective } from '@well/iriro-frontend-libs/bs-component-store';

@Component({
    selector: 'well-route-popup',
    templateUrl: './route-popup.component.html',
    styleUrls: ['./route-popup.component.scss'],
    imports: [BsButtonDirective, BsButtonIconDirective, RouterOutlet]
})
export class RoutePopupComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private elementRef = inject(ElementRef);

  private routedOutletService = inject(RoutedOutletService);

  public close(): void {
    this.router.navigate([{ outlets: { popup: null } }]);
  }

  ngOnInit(): void {
    ZIndexUtils.set('modal', this.elementRef.nativeElement, 1000);
  }

  ngOnDestroy(): void {
    this.routedOutletService.resolve('popup');
  }
}
